export default __webpack_public_path__ + "static/media/ic_document_scanner.12372d43.svg";